import { Button, PageHeader } from 'antd'

import TableBlock from '../../components/tables/TableBlock'
import { getCompanies } from '../../network/B2B'
import { useAuth } from '../../hooks/useAuth'
import { ROLE_PERMISSIONS } from '../../constants/common'

const Companies = () => {
  const { user } = useAuth()
  const permissions = ROLE_PERMISSIONS[user.role]
    ? ROLE_PERMISSIONS[user.role]
    : []

  const filters = (history) => ({
    fields: [
      {
        type: 'text',
        label: 'Name',
        key: 'name',
        noRegex: true,
      },
    ],
    actions: [
      {
        label: '+ Create a company',
        isActive: permissions.includes('new_companies'),
        action: () => history.push(`/companies/create/${user.currentStore}`),
      },
    ],
  })

  const columns = (history) => [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: '',
      key: 'action',
      width: 25,
      render: (e) => {
        return (
          <Button
            onClick={() => history.push(`/companies/${e.id}`)}
            type="primary"
            disabled={permissions.includes('edit_companies') ? false : true}
          >
            Edit
          </Button>
        )
      },
    },
  ]

  return (
    <>
      <PageHeader className="site-page-header" title="Companies" />
      <TableBlock
        columns={columns}
        filters={filters}
        name={'getCompanies'}
        request={getCompanies}
        infinite
        otherFilters={
          user.franchiseStore || !permissions.includes('can-see-franchises')
            ? { store: user.currentStore }
            : {}
        }
      />
    </>
  )
}

export default Companies
